import React from 'react';
import Reflux from 'reflux';
import Revelr from 'configs';
import UserStore from 'stores/userStore';
import EventLocation from 'components/eventLocation';

class LeadCard extends Reflux.Component {
    constructor(props) {
        super(props);

        this.store = UserStore;
        this.handleLeadClick = this.handleLeadClick.bind(this);
    }

    handleLeadClick(leadId) {
        this.context.router.push(`/leads/${leadId}`);
    }

    render() {
        const lead = this.props.lead;

        return (
            <div className={!lead.accepted && !lead.rejected ? 'event-card new' : 'event-card'} key={lead.id} onClick={this.handleLeadClick.bind(this, lead.id)}>
                <div className="event-details">
                    <div className="event-title">{lead.event.title}</div>
                    <div className="event-location">{lead.event.event_type ? `${lead.event.event_type}, ` : ''}<EventLocation location={lead.event.location || lead.event.location_list} /></div>
                    {this.state.user.multiple_vendors && <div className="event-vendor">{lead.vendor_name}</div>}
                </div>

                <p className="event-date">{lead.event.date.format(Revelr.dateFormat)}</p>
            </div>
        );
    }
}

LeadCard.contextTypes = {
    router: React.PropTypes.object,
};

LeadCard.propTypes = {
    lead: React.PropTypes.object.isRequired,
};

export default LeadCard;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/leadCard.jsx